import HttpClient from "@/common/boot/HttpClient"

const listarMenus = async({ commit }, payload) => {

    commit('CARREGANDO', true);

    await HttpClient.get('/menus', payload).then(response => {
            commit('LISTAR_DADOS', response.data.data);
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

// const listarOrdenacao = async({ commit }, payload) => {

//     commit('CARREGANDO', true);

//     await HttpClient.get(`/app/menus/listar-ordenacao/${payload}`, payload).then(response => {
//             commit('LISTAR_ORDENACAO', response.data.data);
//             return response;
//         })
//         .finally(() => {
//             commit('CARREGANDO', false);
//         });
// }


const excluirMenus = async({ dispatch }, payload) => {
    let qtdRows = payload.length;
    for (let i = 0; i < qtdRows; ++i) {
        await excluir(payload[i]);
    }
    dispatch('listarMenus');
}

const excluir = async(linha) => {
    const resp = await HttpClient.delete(`/menus/${linha.id}`).then(response => { return response; });
    return resp;
}

const salvarMenu = async({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.post('/menus', payload).then(response => {
            dispatch('listarMenus');
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        });
}

const recuperarMenu = ({ commit, state }, payload) => {

    const menu = state.items.filter(menu => menu.id === payload.id);

    if (menu.length) {
        commit('INSERIR_MENU_SELECIONADO', ...menu);
        return true;
    }

    return false;
}

const atualizarMenu = async({ commit, dispatch }, payload) => {
    commit('CARREGANDO', true);

    return await HttpClient.put(`/menus/${payload.id}`, payload).then(response => {
            dispatch('listarMenus');
            return response;
        })
        .finally(() => {
            commit('CARREGANDO', false);
        })
}


export {
    listarMenus,
    excluirMenus,
    salvarMenu,
    recuperarMenu,
    atualizarMenu,
    // listarOrdenacao
}